import { right } from "fp-ts/lib/Either";
import di from "../../../../../di/DependencyInjection";
import Host2Api, { Host2ApiName } from "../../../../settings/Host2Api";

const GetNewsApiImpl = async (): Promise<any> => {
    const finalParam = '/get-news';
    const response = await di.get<Host2Api>(Host2ApiName).get(finalParam);
    
    // Host2Api.get() returns either JSON object or text string
    // Convert to string if it's an object, otherwise use as is
    const result = typeof response === 'string' ? response : JSON.stringify(response);
    
    return right(result);
}

export default GetNewsApiImpl;
